const CONSTANTS = {
  timestamp: 'MM/dd/yyy - h:mm:ss a',
  // Client-side bulk-download cap. Must match document-api MAX_BULK_DOWNLOAD;
  // the server 400 response still backstops any drift.
  maxBulkDownload: 100
}

const DOCTYPES = [
  {
    category: 'REPORTS',
    type: 'IPRO_BILLING'
  },
  {
    category: 'REPORTS',
    type: 'SRP_ALERT'
  }
]

export default { CONSTANTS, DOCTYPES }
